import Axios from "../utils/axiosInstance";

// API for live search RO during ticket raising
export const getRoLiveSearch = (params = {}, headers) => {
  let token = sessionStorage.getItem("token");
  return Axios.get(`/ro_onboarding/live-search`, {
    params,
    headers: headers || { Authorization: `Bearer ${token}` },
  });
};

// API for getting RO onboarding list
export const getRoList = (userId, role, headers) => {
  let token = sessionStorage.getItem("token");
  return Axios.get(`/ro_onboarding/getRoList`, {
    params: { userId, role },
    headers: headers || { Authorization: `Bearer ${token}` },
  });
};

// API for sending OTP in RO Onboarding
export const sendRoOTP = (payload, headers) => {
  let token = sessionStorage.getItem("token");
  return Axios.post(`/ro_onboarding/toSendOTP`, payload, {
    headers: headers || {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

// API for validating OTP in RO Onboarding
export const validateRoOTP = (params = {}, headers) => {
  let token = sessionStorage.getItem("token");
  return Axios.get(`/ro_onboarding/validateOTP`, {
    params,
    headers: headers || { Authorization: `Bearer ${token}` },
  });
};

// API for creating RO entry
export const createRO = (payload, headers) => {
  let token = sessionStorage.getItem("token");
  return Axios.post(`/ro_onboarding/createRO`, payload, {
    headers: headers || {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

// API for updating RO entry
export const updateRO = (roId, payload, headers) => {
  let token = sessionStorage.getItem("token");
  return Axios.put(`/ro_onboarding/updateRO/${roId}`, payload, {
    headers: headers || {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

// API for getting RO Manager dropdown
export const getRoManagerDropDown = (headers) => {
  let token = sessionStorage.getItem("token");
  return Axios.get(`/User/getRoManagerDropDown`, {
    headers: headers || { Authorization: `Bearer ${token}` },
  });
};
